enum routesName {
  LOGIN = '/login',
  FORGETPASSWORD = '/forgetPassword',
  DASHBOARD = '/dashboard',
  USERS='users',
  ADDUSER='addUser',
  EDITUSER='editUser/:id',
  ROLES='roles',
  EDITROLE='editRole/:id',
  ADDROLE='addRole',
  CHANNELS='channels',
  ADDCHANNEL='addChannel' ,
  ROLESLIST='rolesList',
  ROLEDETAIL='roleDetail/:id',
  USERSLIST='usersList',
  USERDETAIL='userDetail/:id',
  CHANNELSLIST='channelsList',
  CHANNELDETAIL='channelDetail/:id',
  EDITCHANNEL='editChannel/:id',
  GROUPS='groups',
  ADDGROUP='addGroup',
  EDITGROUP='editGroup/:id',
  GROUPDETAIL='groupDetail/:id',
  GROUPSLIST='groupList',
  OPRATIONALACCESS='operationalAccess',
  OPRATIONALACCESSLIST='oprationalAccessList',
  OPRATIONALACCESSDETAIL='oprationalAccessDetail/:id',
  EDITOPRATIONALACCESS='editOprationalAccess/:id',
  ACCESS='access',
  ACCESSLIST='accessList',
  ACCESSDETAIL='accessDetail/:id',
  EDITACCESS='editAccess/:id',
  REPORTS='reports',
  CALLSREPORT='callReports',
  MESSAGESREPORT='messagesReport',
  CREATEOPERATIONALACCESS='createOperationalAccess',
  MANDATORYMEMBERSHIPLIST='mandatoryMembershipList',
  MANDANTORYMEMBERSHIPDETAIL='mandantoryMembershipDetail/:id',
  EDITMANDANTORYMEMBERSHIP='EditMandantoryMembership/:id',
  CREATEMANDANTORYMEMBERSHIP='CreateMandantoryMembership',
  CATEGORIES='categories',
  ADDCATEGORY='addCategory',
  CATEGORIESLIST='categoriesList',
  EDITCATEGORY='editCategory/:id'
}

const persistkeys = {
  theme: 'THEME',
  language: 'LANGUAGE',
  accessToken:'accessToken'
};

export { persistkeys, routesName };
